// @ts-check
// src/stores/products.js — Faza E.2 / Sesja 3.5 — Products state in Nanostores
//
// 17.09.2026: atomy listy Produktów V1 ($productsFilters, $productsView, $productsPage,
// $selectedProductId, $productsList, $productsPanelVisible) usunięte razem z listą —
// nic ich nie czytało. Lista żyje w Katalogu V2 (stan w URL, `catalog-workspace-state.ts`).

import { atom } from 'nanostores';

/** Lista kategorii produktów (cache, ładowane raz) — edytor produktu w karcie i modalu. */
export const $categoriesList = atom(/** @type {any[]} */ ([]));

if (typeof window !== 'undefined') {
  window.__sbStores = Object.assign(window.__sbStores || {}, {
    $categoriesList,
  });
}
